import { Children } from "react";
import { View, YStack } from "tamagui";
import { Separator } from "./Separator";

export const Group = ({
  children,
  borderBottom,
  borderTop = true,
}: {
  children: React.ReactNode | React.ReactNode[];
  borderTop?: boolean;
  borderBottom?: boolean;
}) => {
  const items = Children.toArray(children);

  if (!items.length) {
    return null;
  }

  return (
    <YStack
      flex={1}
      borderRadius={0}
      gap="$medium"
      justifyContent="center"
      padding={0}
      paddingTop={borderTop ? "$space.medium" : 0}
      paddingBottom={borderBottom ? "$space.medium" : 0}
      separator={<Separator noMargins />}
      borderTopWidth={borderTop ? 1 : 0}
      borderBottomWidth={borderBottom ? 1 : 0}
      borderColor={"$divider"}
    >
      {items.map((item, index) => (
        <View
          key={`_${index}`}
          overflow="visible"
          flexDirection="column"
          padding={0}
          backgroundColor={"transparent"}
          borderWidth={0}
          alignItems="flex-start"
          width="100%"
        >
          {item}
        </View>
      ))}
    </YStack>
  );
};
